// We're getting a bunch of html from the server and shoving it into react here.

import * as React from 'react';
import {Helmet} from 'react-helmet';

import {api} from 'nutshell-core/api';

import {headTitle} from 'shells/document/head-title';

import {AppErrorHandler} from '../errors/app-error-handler';
import {PageWrapper} from '../layout/page-wrapper';

type Props = {
    noteId: string;
};

export class NotePage extends React.Component<Props> {
    componentDidMount() {
        api.get(`/notes/${this.props.noteId}`)
            // @ts-expect-error
            .then((res) => res.json())
            .then((res) => Nut.RestService.parseTopLevelResponse(res))
            .then(() => {
                const model = Nut.Model.getModel({
                    id: `${this.props.noteId}-notes`,
                    type: 'notes',
                });

                const view = Nut.View.timelineEvent.createViewForModel(model, {
                    detailView: true,
                    displayComments: true,
                });
                $('#entry-container .timeline3-entry').replaceWith(view.$el);
            })
            .then(() => {
                api.post(`views/${this.props.noteId}-notes`, {});
            });
    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>{headTitle('Note details')}</title>
                </Helmet>
                <PageWrapper>
                    <AppErrorHandler>
                        <div id='entry-container' className='timeline3-list variant-full'>
                            <div className='timeline3-entry state-expanded type-note' />
                            <div className='timeline3-end'>
                                <div className='line' />
                                <div className='dot' />
                            </div>
                        </div>
                    </AppErrorHandler>
                </PageWrapper>
            </React.Fragment>
        );
    }
}
